module.exports = "img/step3.76438f.jpeg";